export const AuthType = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_RESPONSE: 'LOGIN_RESPONSE',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    UNAUTHORIZED_REQUEST: 'UNAUTHORIZED_REQUEST',
    UNAUTHORIZED_SUCCESS: 'UNAUTHORIZED_SUCCESS',
  }
  
  export const RoleType = {
    GET_LIST_ROLE_REQUEST:'GET_LIST_ROLE_REQUEST',
    SEARCH_LIST_ROLE_REQUEST:'SEARCH_LIST_ROLE_REQUEST'
  }

  export const PermissionType = {
    GET_LIST_PERMISSION: 'GET_LIST_PERMISSION',
  }
  